import React from "react";
import { Button, TextField, Form } from "@vitalsource/vstui";
import { Translation, t } from "../../../core/translate";
import { FormAlert } from "../form-alert";
import { emailPattern } from "../utils";

const resend = () => (
  <div>
    <FormAlert level="warning" key="email-sent">
      <Translation id="forgot-password.forgot-sent-text">
        If an account exists with this email, a confirmation message has been
        sent.
      </Translation>
      <Button type="submit" size="small" inline>
        {t("forgot-password.resend", "Resend")}
      </Button>
    </FormAlert>
  </div>
);

export default ({ resetPassword, passwordReset }) => (
  <Form onSubmit={resetPassword} id="forgot-form" method="post">
    <TextField
      required
      fullWidth
      id="email-field"
      type="email"
      name="email"
      label={t("base.email", "Email Address")}
      size="large"
      pattern={emailPattern}
    />
    {!passwordReset && (
      <Button id="submit-btn" fullWidth size="large">
        {t("base.submit")}
      </Button>
    )}
    {passwordReset && resend()}
  </Form>
);
